// @flow

import cn from 'classnames';
import React from 'react';
import ContentEditable from 'react-contenteditable';

import type { CustomButtonStyles } from '../CallToAction';

import './style.pcss';

type Props = {|
  locale: string,
  blockType: string,
  isServerSideRender: boolean,
  onChangeText: Function,
  onBlur: Function,
  onClick: Function,
  callToAction: Object,
  theme: CustomButtonStyles
|};

const LightBox = ({
  isServerSideRender,
  locale,
  onChangeText,
  onBlur,
  theme,
  onClick,
  callToAction,
  blockType
}: Props) => {
  const { value, label } = callToAction;
  const { link } = value;

  const fancybox = link ? { 'data-fancybox': '' } : {};

  // TODO copy-paste from link custom button
  return (
    isServerSideRender ? (
      <a
        {...fancybox}
        className='ui-site-calltoaction ui-site-calltoaction--link swiper-no-swiping'
        // TODO move to css-vars theme
        style={theme}
        href={link || 'javascript:void(0)'} // eslint-disable-line
        data-xa-method='elementClick'
        data-xa-name='light_box'
        data-xa-extra={JSON.stringify({
          link,
          block: blockType
        })}
      >
        <div className={cn('ui-site-calltoaction__text')}>
          {label[locale]}
        </div>
      </a>
    ) : (
      <button
        className='ui-site-calltoaction ui-site-calltoaction--link swiper-no-swiping'
        style={theme}
        onClick={onClick}
      >
        <div className='ui-site-calltoaction__text'>
          <ContentEditable
            html={label[locale]}
            onChange={onChangeText}
            onBlur={onBlur}
          />
        </div>
      </button>
    )
  );
};

export default LightBox;
